export default function PassTicketsLoading() {
  return (

    <div className="space-y-3">
      {[...Array(20).keys()].map((i) => (
        <div key={i} className="rounded-2xl border border-neutral-200 bg-white">
          <div className="p-1 my-1 mx-2">
            <div className="animate-pulse flex space-x-4 w-2/3">
              <div className="flex-1 space-y-1 py-2">
                <div className="h-7 bg-slate-300 rounded"></div>
              </div>
            </div>
            <div className="animate-pulse grid grid-cols-3 place-items-center">
              <div className="rounded-2xl my-1 shadow-md bg-slate-300 h-24 w-24"></div>
              <div className="col-span-2 overflow-y-auto h-28 w-full">
                <div className="p-1 m-2 space-y-2">
                  <div className="h-6 bg-slate-300 rounded"></div>
                  <div className="h-6 bg-slate-300 rounded"></div>
                  <div className="h-6 bg-slate-300 rounded"></div>
                </div>
              </div>
            </div>
            {/* <div className="animate-pulse flex space-x-4">
              <div className="rounded-2xl bg-slate-300 h-24 w-24"></div>
              <div className="flex-1 space-y-3 py-1">
                <div className="h-5 bg-slate-300 rounded"></div>
                <div className="h-5 bg-slate-300 rounded"></div>
                <div className="h-5 bg-slate-300 rounded"></div>
              </div>
            </div> */}
            <div className="animate-pulse flex space-x-4">
              <div className="flex-1 space-y-1 py-2">
                <div className="h-4 bg-slate-300 rounded"></div>
                <div className="h-4 bg-slate-300 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}